import { AgxPropertyAddressForm, AgxPropertyAttributes } from '@urbanx/agx-ui-components';
import { AgxSpacer, AgxTypography } from '@urbanx/agx.ui-components2';
import Panel from 'components/panel/Panel';
import {
  AustralianAddress,
  CampaignDetailModelState,
  PropertyAttributesModel,
} from '@urbanx/agx.campaigns.client';

interface PropertyDetailsSectionProps {
  propertyAddress: AustralianAddress | undefined;
  campaignState: CampaignDetailModelState | undefined;
  setPropertyAddress: (value: AustralianAddress | undefined) => void;
  propertyAttributes: PropertyAttributesModel | undefined;
  hidePropertyAttributes?: string[];
  setPropertyAttributes: (value: PropertyAttributesModel | undefined) => void;
  hasUnsavedChanges: boolean;
}

const PropertyDetailsSection = ({
  propertyAddress,
  campaignState,
  setPropertyAddress,
  propertyAttributes,
  hidePropertyAttributes,
  setPropertyAttributes,
  hasUnsavedChanges,
}: PropertyDetailsSectionProps) => {
  return (
    <AgxSpacer id="property-details" direction="vertical" gap="spacing-xl" fill>
      <Panel
        title={
          <AgxTypography id="propertyDetailsTitle" type="body" size="medium">
            Property Details
          </AgxTypography>
        }
        padding={{
          top: 'md',
          bottom: 'md',
          left: 'xl',
          right: 'xl',
        }}
      >
        <AgxSpacer direction="vertical" gap="spacing-xl" fill>
          <AgxPropertyAddressForm
            key={`PropertyAddress-${propertyAddress?.state}`}
            id="propertyDetailsAddress"
            label="Property Address"
            onAddressSelected={(address) =>
              setPropertyAddress({
                unitNumber: address.unitNumber,
                streetAddress: address.streetAddress,
                suburb: address.suburb,
                state: address.state,
                postalCode: address.postalCode,
                country: address.country,
              })
            }
            allowParentUpdates
            defaultValue={propertyAddress}
            propertyAddressField={false}
            showSearchForAddress={false}
            stateToSearch={campaignState}
            required
            validate={hasUnsavedChanges}
          />
        </AgxSpacer>
      </Panel>
      <Panel
        title={
          <AgxTypography id="propertyAttributesTitle" type="body" size="medium">
            Property Attributes
          </AgxTypography>
        }
        padding={{
          top: 'md',
          bottom: 'md',
          left: 'xl',
          right: 'xl',
        }}
      >
        <AgxSpacer direction="vertical" gap="spacing-xl" fill>
          <AgxPropertyAttributes
            key={`PropertyAttirbutes-${propertyAttributes?.propertyType}`}
            id="PropertyAttributes"
            defaultValue={propertyAttributes}
            onChange={({ value }) =>
              setPropertyAttributes({
                builtOnOrVacantLandType: value.builtOnOrVacantLandType,
                propertyType: value.propertyType,
                numberOfBeds: value.numberOfBeds,
                numberOfBathrooms: value.numberOfBathrooms,
                numberOfCarSpaces: value.numberOfCarSpaces,
                landAreaDetails: value.landAreaDetails,
                ruralType: value.ruralType,
              })
            }
            validate={hasUnsavedChanges}
            hidePropertyAttributes={hidePropertyAttributes}
          />
        </AgxSpacer>
      </Panel>
    </AgxSpacer>
  );
};

export default PropertyDetailsSection;
